export type HttpMonitorModalType = 'edit' | 'delete' | 'pause' | 'resume' | 'tags' | 'limit' | null;

export type HttpMonitorBackgroundKind = 'en' | 'paused' | 'ok' | 'problem';

export function getHttpMonitorDisplayName(name: string | null | undefined): string {
    return name
        ? name.replace(/^https?:\/\//, '').replace(/\/$/, '')
        : '';
}

export function getHttpMonitorBackgroundKind(
    status: string | null | undefined,
    lastCode: string | number | null | undefined,
    isEnglish: boolean,
): HttpMonitorBackgroundKind {
    if (isEnglish) {
        return 'en';
    }

    if (status === 'paused') {
        return 'paused';
    }

    if (lastCode === '2xx' || String(lastCode).startsWith('2')) {
        return 'ok';
    }

    return 'problem';
}
